import React from 'react';
import Swal from 'sweetalert2';
import './contact.css';

const Contact = () => {
  const messageFromUser = e => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const message = form.message.value;

    const userMessage = {
      name: name,
      email: email,
      message: message,
    };

    console.log(userMessage);

    fetch('https://my-server-iota.vercel.app/invites', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(userMessage),
    })
      .then(data => data.json())
      .then(res => {
        console.log(res);
        if (res.acknowledged) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Thank you for contact with me',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err,
          footer: '<a href="">Why do I have this issue?</a>',
        });
      });
  };

  return (
    <div className="px-[8%] py-6 getTouch bg-gray-800 text-white overflow-hidden " id="contacts">
      <section className="py-6 text-white  ">
        <div className="grid max-w-6xl grid-cols-1  mx-auto  md:grid-cols-2 md:divide-x">
          <div
            className="py-6 md:py-0 md:px-6"
            data-aos="fade-right"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
          >
            <h1 className="text-4xl font-bold">Get in touch</h1>
            <p className="pt-2 pb-4">
              Fill in the form to start a conversation
            </p>
            <div className="space-y-4">
              <p className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5 mr-2 sm:mr-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span>Chittagong, Bangladesh</span>
              </p>
              <p className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5 mr-2 sm:mr-6"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
                </svg>
                <span>
                  <a
                    className=" text-lg text-gray-100"
                    href="tel:+880160-1188696"
                  >
                    +880160-1188696
                  </a>
                </span>
              </p>
              <p className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  fill="currentColor"
                  className="w-5 h-5 mr-2 sm:mr-6"
                >
                  <path
                    d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
                <span>
<a
  className="text-lg text-gray-100"
  href="https://api.whatsapp.com/send?phone=8801601188696"
  target="_blank"
  rel="noopener noreferrer"
>
  +880160-1188696
</a>

                </span>
              </p>

              <p className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5 mr-3 sm:mr-6"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
                <span>
                  <a
                    className=" text-lg visible text-gray-100"
                    href="mailto:kutubuddin98710@gmail.com"
                  >
                    kutubuddin98710@gmai.com
                  </a>
                </span>
              </p>
            </div>
          </div>
          <form
            data-aos="fade-left"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            noValidate=""
            onSubmit={messageFromUser}
            className="flex flex-col space-y-6 md:py-0 md:px-6 ng-untouched ng-pristine ng-valid"
          >
            <label className="block">
              <span className="mb-1 text-gray-100">Full name</span>
              <input
                type="text"
                name="name"
                required
                placeholder="Name"
                className="block w-full rounded-md shadow-sm focus:ring focus:ring-opacity- py-3 px-3  bg-gray-100"
              />
            </label>
            <label className="block">
              <span className="mb-1 text-gray-100">Email address</span>
              <input
                type="email"
                name="email"
                required
                placeholder="Email"
                className="block w-full rounded-md shadow-sm focus:ring focus:ring-opacity-75  py-3 px-3 bg-gray-100"
              />
            </label>
            <label className="block">
              <span className="mb-1 text-gray-100">Message</span>
              <textarea
                rows="3"
                name="message"
                required
                className="block w-full rounded-md focus:ring focus:ring-opacity-75  bg-gray-100"
              ></textarea>
            </label>
            <button
              type="submit"
              className="self-center px-8 py-3 text-lg rounded focus:ring hover:ring focus:ring-opacity-75 bg-slate-900 text-gray-50 focus:ring-white hover:ring-white"
            >
              Submit
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
